import { ReactNode } from "react"

import { ErrorPage } from "components/ErrorBoundary/ErrorPage"
import { browserInfo } from "utils"

interface Props {
    children: ReactNode
}

export function BrowserCheck({ children }: Props) {
    if (browserInfo.isIE()) {
        alert("К сожалению, мы не поддерживаем ваш браузер")
        return <ErrorPage />
    }
    return <>{children}</>
}
